import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Utilities } from "./utilities";
import { HttpClient } from "@angular/common/http";
import { ENV } from "@app/env";

@Injectable()
export class CampaingService {

  public action = "edit";

  constructor(
    private afdb: AngularFireDatabase,
    private utilities: Utilities,
    private http: HttpClient,
  ) { }

  public getCampaingList(clientId: string) {
    return this.afdb.list<any>(`Clients/${clientId}/Campaings`).valueChanges();
  }

  public getCampaing(clientId: string, campaingId: string) {
    return this.afdb.object<any>(`Clients/${clientId}/Campaings/${campaingId}`).valueChanges();
  }

  public detailCampaing(campaingId: string, stats: boolean) {
    return this.http.get(`${ENV.backend}/campains/campains_search/${campaingId}?stats=${stats}`)
  }

  public sendCampaing(campaingId: string) {
    return this.http.post(`${ENV.backend}/campains/send/${campaingId}`, {});
  }

  public sendCampaingTest(campaingId: string, test_emails: string[]) {
    return this.http.post(`${ENV.backend}/campains/test/${campaingId}`, {
      test_emails,
      send_type: 'html'
    });
  }

  public createOrEditCampaing(payload: any) {
    return new Promise((res, rej) => {
      if (payload.id !== '') {
        this.http.patch(`${ENV.backend}/campains/${payload.id}`, payload).subscribe((response) => {
          if (response) {
            res(response);
          } else {
            rej();
          }
        });
      } else {
        this.http.post(`${ENV.backend}/campains`, payload).subscribe((response) => {
          if (response) {
            res(response);
          } else {
            rej();
          }
        });
      }
    });
  }

  public getAudienceList(clientId: string) {
    return this.afdb.list<any>(`Clients/${clientId}/Audience`).valueChanges();
  }

  public getAudience(clientId: string, audienceId: string) {
    return this.afdb.object<any>(`Clients/${clientId}/Audience/${audienceId}`).valueChanges();
  }

  public detailAudience(audienceId: string) {
    return this.http.get(`${ENV.backend}/campains/audience/${audienceId}`);
  }

  public createOrEditAudience(payload: any) {
    return new Promise((res, rej) => {
      this.http.post(`${ENV.backend}/campains/audience`, payload).subscribe((response) => {
        if (response) {
          res(response);
        } else {
          rej();
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/campaing.service.ts